import React, { Component } from "react";

class SelectAudit extends Component {
  handleAuditChange=(e)=>{
    let {auditorsData}=this.props.parentState;
    this.props.liftGlobalState({name:'pageData'},auditorsData[e.target.value].pageData);
    this.props.liftGlobalState({name:'auditorsSelection'},e.target.value);
  }

  render () {
    let {auditorsData}=this.props.parentState;
    return (
      <select onChange={this.handleAuditChange}>
        {auditorsData.map((row,idx)=><option value={idx}>{row.timestamp}</option>)
        }
      </select>
    )
  }
}

export default SelectAudit;